import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Vehicle } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createVehicleApi, vehicleKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useArchiveVehicle(): UseMutationResult<Vehicle, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createVehicleApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<Vehicle, Error, string>({
    mutationFn: (id: string) => api.archiveVehicle(id),
    ...createMutationCallbacks({
      errorKey: 'vehicles.toast.archiveError',
      invalidateKeys: [vehicleKeys.all],
      queryClient,
      successKey: 'vehicles.toast.archived',
      t,
    }),
  });
}
